import * as i0 from '@angular/core';
import { InjectionToken, inject, ElementRef, input, booleanAttribute, computed, signal, Directive, DestroyRef, Injector, viewChild, contentChild, contentChildren, effect, afterNextRender, untracked, ChangeDetectionStrategy, Component, TemplateRef, PLATFORM_ID, numberAttribute, model, NgModule } from '@angular/core';
import { NgTemplateOutlet, isPlatformBrowser } from '@angular/common';
import { takeUntilDestroyed, toSignal, toObservable } from '@angular/core/rxjs-interop';
import { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import { Subject, fromEvent, interval, of } from 'rxjs';
import { takeUntil, switchMap, delay, map } from 'rxjs/operators';
import * as i1 from '@spartan-ng/brain/label';
import { BrnLabelDirective } from '@spartan-ng/brain/label';
import { NgControl, NgForm, FormGroupDirective } from '@angular/forms';
import { CdkListboxModule } from '@angular/cdk/listbox';
import * as i1$1 from '@angular/cdk/overlay';
import { CdkConnectedOverlay, OverlayModule } from '@angular/cdk/overlay';
import { provideExposedSideProviderExisting, provideExposesStateProviderExisting } from '@spartan-ng/brain/core';
import { BrnFormFieldControl } from '@spartan-ng/brain/form-field';
import { ErrorStateMatcher, ErrorStateTracker } from '@spartan-ng/brain/forms';
const _c0 = ["viewport"];
const _c1 = ["*", [["hlm-select-scroll-up"]], [["brnSelectScrollUp"]], [["brnSelectScrollDown"]], [["hlm-select-scroll-down"]]];
const _c2 = ["*", "hlm-select-scroll-up", "brnSelectScrollUp", "brnSelectScrollDown", "hlm-select-scroll-down"];
function BrnSelectContentComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
    i0.ɵɵprojection(1, 2);
  }
}
function BrnSelectContentComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BrnSelectContentComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
    i0.ɵɵprojection(1, 4);
  }
}
function BrnSelectContentComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c3 = a0 => ({
  $implicit: a0
});
function BrnSelectValueComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultPlaceholderTemplate_r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", (tmp_3_0 = (tmp_3_0 = ctx_r0.customPlaceholderTemplate()) == null ? null : tmp_3_0.templateRef) !== null && tmp_3_0 !== undefined ? tmp_3_0 : defaultPlaceholderTemplate_r2);
  }
}
function BrnSelectValueComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultValueTemplate_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", (tmp_3_0 = (tmp_3_0 = ctx_r0.customValueTemplate()) == null ? null : tmp_3_0.templateRef) !== null && tmp_3_0 !== undefined ? tmp_3_0 : defaultValueTemplate_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c3, ctx_r0._select.value()));
  }
}
function BrnSelectValueComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r0.value());
  }
}
function BrnSelectValueComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder());
  }
}
const _c4 = [[["hlm-select-trigger"], ["", "brnSelectTrigger", ""]], [["label", "hlmLabel", ""], ["label", "brnLabel", ""]], "*"];
const _c5 = ["hlm-select-trigger,[brnSelectTrigger]", "label[hlmLabel],label[brnLabel]", "*"];
function BrnSelectComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.labelId());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.placeholder());
  }
}
function BrnSelectComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function BrnSelectComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
const BrnSelectContentToken = new InjectionToken('BrnSelectContentToken');
function injectBrnSelectContent() {
  return inject(BrnSelectContentToken);
}
function provideBrnSelectContent(select) {
  return {
    provide: BrnSelectContentToken,
    useExisting: select
  };
}
const BrnSelectToken = new InjectionToken('BrnSelectToken');
function injectBrnSelect() {
  return inject(BrnSelectToken);
}
function provideBrnSelect(select) {
  return {
    provide: BrnSelectToken,
    useExisting: select
  };
}
let nextId$1 = 0;
let BrnSelectOptionDirective = /*#__PURE__*/(() => {
  class BrnSelectOptionDirective {
    _select = injectBrnSelect();
    _content = injectBrnSelectContent();
    elementRef = inject(ElementRef);
    id = input(`brn-option-${nextId$1++}`);
    value = input();
    // we use "_disabled" here because disabled is already defined in the Highlightable interface
    _disabled = input(false, {
      alias: 'disabled',
      transform: booleanAttribute
    });
    get disabled() {
      return this._disabled();
    }
    selected = computed(() => this.value() !== undefined && this._select.isSelected(this.value()));
    _active = signal(false);
    checkedState = computed(() => this.selected() ? 'checked' : 'unchecked');
    dir = this._select.dir;
    select() {
      if (this._disabled()) {
        return;
      }
      if (this._select.multiple()) {
        this._select.toggleSelect(this.value());
        return;
      }
      this._select.selectOption(this.value());
    }
    /** Get the label for this element which is required by the FocusableOption interface. */
    getLabel() {
      return this.elementRef.nativeElement.textContent?.trim() ?? '';
    }
    setActiveStyles() {
      this._active.set(true);
      // scroll the option into view if it is not visible
      this.elementRef.nativeElement.scrollIntoView({
        block: 'nearest'
      });
    }
    setInactiveStyles() {
      this._active.set(false);
    }
    activate() {
      if (this._disabled()) {
        return;
      }
      this._content.setActiveOption(this);
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectOptionDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectOptionDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectOptionDirective,
      selectors: [["", "brnOption", ""]],
      hostAttrs: ["role", "option"],
      hostVars: 6,
      hostBindings: function BrnSelectOptionDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function BrnSelectOptionDirective_click_HostBindingHandler() {
            return ctx.select();
          })("mouseenter", function BrnSelectOptionDirective_mouseenter_HostBindingHandler() {
            return ctx.activate();
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id());
          i0.ɵɵattribute("aria-selected", ctx.selected())("aria-disabled", ctx._disabled())("dir", ctx._select.dir())("data-active", ctx._active() ? "" : undefined)("data-disabled", ctx._disabled() ? "" : undefined);
        }
      },
      inputs: {
        id: [1, "id"],
        value: [1, "value"],
        _disabled: [1, "disabled", "_disabled"]
      }
    });
  }
  return BrnSelectOptionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SCROLLBY_PIXELS = 100;
let BrnSelectScrollUpDirective = /*#__PURE__*/(() => {
  class BrnSelectScrollUpDirective {
    _el = inject(ElementRef);
    _selectContent = inject(BrnSelectContentComponent);
    _endReached = new Subject();
    _destroyRef = inject(DestroyRef);
    startEmittingEvents() {
      const mouseLeave$ = fromEvent(this._el.nativeElement, 'mouseleave');
      interval(100).pipe(takeUntil(mouseLeave$), takeUntil(this._endReached), takeUntilDestroyed(this._destroyRef)).subscribe(() => this._selectContent.moveFocusUp());
    }
    stopEmittingEvents() {
      this._endReached.next(true);
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectScrollUpDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectScrollUpDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectScrollUpDirective,
      selectors: [["", "brnSelectScrollUp", ""], ["brn-select-scroll-up"], ["hlm-select-scroll-up", 5, "noHlm"]],
      hostAttrs: ["aria-hidden", "true"],
      hostBindings: function BrnSelectScrollUpDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function BrnSelectScrollUpDirective_mouseenter_HostBindingHandler() {
            return ctx.startEmittingEvents();
          });
        }
      }
    });
  }
  return BrnSelectScrollUpDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectScrollDownDirective = /*#__PURE__*/(() => {
  class BrnSelectScrollDownDirective {
    _el = inject(ElementRef);
    _selectContent = inject(BrnSelectContentComponent);
    _endReached = new Subject();
    _destroyRef = inject(DestroyRef);
    startEmittingEvents() {
      const mouseLeave$ = fromEvent(this._el.nativeElement, 'mouseleave');
      interval(100).pipe(takeUntil(mouseLeave$), takeUntil(this._endReached), takeUntilDestroyed(this._destroyRef)).subscribe(() => this._selectContent.moveFocusDown());
    }
    stopEmittingEvents() {
      this._endReached.next(true);
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectScrollDownDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectScrollDownDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectScrollDownDirective,
      selectors: [["", "brnSelectScrollDown", ""], ["brn-select-scroll-down"], ["hlm-select-scroll-down", 5, "noHlm"]],
      hostAttrs: ["aria-hidden", "true"],
      hostBindings: function BrnSelectScrollDownDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function BrnSelectScrollDownDirective_mouseenter_HostBindingHandler() {
            return ctx.startEmittingEvents();
          });
        }
      }
    });
  }
  return BrnSelectScrollDownDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectContentComponent = /*#__PURE__*/(() => {
  class BrnSelectContentComponent {
    _elementRef = inject(ElementRef);
    _injector = inject(Injector);
    _select = injectBrnSelect();
    canScrollUp = signal(false);
    canScrollDown = signal(false);
    viewport = viewChild.required('viewport');
    scrollUpBtn = contentChild(BrnSelectScrollUpDirective);
    scrollDownBtn = contentChild(BrnSelectScrollDownDirective);
    _options = contentChildren(BrnSelectOptionDirective, {
      descendants: true
    });
    /** @internal */
    keyManager = null;
    constructor() {
      effect(() => {
        this._select.open() && afterNextRender(() => this.updateArrowDisplay(), {
          injector: this._injector
        });
      });
    }
    ngAfterContentInit() {
      this.keyManager = new ActiveDescendantKeyManager(this._options, this._injector).withHomeAndEnd().withVerticalOrientation().withTypeAhead().withAllowedModifierKeys(['shiftKey']).withWrap().skipPredicate(option => option._disabled());
      effect(() => {
        // any time the select is opened, we need to focus the first selected option or the first option
        const open = this._select.open();
        const options = this._options();
        if (!open || !options.length) {
          return;
        }
        untracked(() => {
          const selectedOption = options.find(option => option.selected());
          if (selectedOption) {
            this.keyManager?.setActiveItem(selectedOption);
          } else {
            this.keyManager?.setFirstItemActive();
          }
        });
      }, {
        injector: this._injector
      });
    }
    updateArrowDisplay() {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = this.viewport().nativeElement;
      this.canScrollUp.set(scrollTop > 0);
      const maxScroll = scrollHeight - clientHeight;
      this.canScrollDown.set(Math.ceil(scrollTop) < maxScroll);
    }
    handleScroll() {
      this.updateArrowDisplay();
    }
    focusList() {
      this._elementRef.nativeElement.focus();
    }
    moveFocusUp() {
      this.viewport().nativeElement.scrollBy({
        top: -SCROLLBY_PIXELS,
        behavior: 'smooth'
      });
      if (this.viewport().nativeElement.scrollTop === 0) {
        this.scrollUpBtn()?.stopEmittingEvents();
      }
    }
    moveFocusDown() {
      this.viewport().nativeElement.scrollBy({
        top: SCROLLBY_PIXELS,
        behavior: 'smooth'
      });
      const viewportSize = this._elementRef.nativeElement.scrollHeight;
      const viewportScrollPosition = this.viewport().nativeElement.scrollTop;
      if (viewportSize + viewportScrollPosition + SCROLLBY_PIXELS > this.viewport().nativeElement.scrollHeight + SCROLLBY_PIXELS / 2) {
        this.scrollDownBtn()?.stopEmittingEvents();
      }
    }
    setActiveOption(option) {
      const index = this._options().findIndex(o => o === option);
      if (index === -1) {
        return;
      }
      this.keyManager?.setActiveItem(index);
    }
    selectActiveItem(event) {
      event.preventDefault();
      const activeOption = this.keyManager?.activeItem;
      if (activeOption) {
        this._select.selectOption(activeOption.value());
      }
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectContentComponent)();
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BrnSelectContentComponent,
      selectors: [["brn-select-content"], ["hlm-select-content", 5, "noHlm"]],
      contentQueries: function BrnSelectContentComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.scrollUpBtn, BrnSelectScrollUpDirective, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.scrollDownBtn, BrnSelectScrollDownDirective, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx._options, BrnSelectOptionDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(3);
        }
      },
      viewQuery: function BrnSelectContentComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.viewport, _c0, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostAttrs: ["role", "listbox", "tabindex", "0", "aria-orientation", "vertical"],
      hostVars: 7,
      hostBindings: function BrnSelectContentComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function BrnSelectContentComponent_keydown_HostBindingHandler($event) {
            return ctx.keyManager == null ? null : ctx.keyManager.onKeydown($event);
          })("keydown.enter", function BrnSelectContentComponent_keydown_enter_HostBindingHandler($event) {
            return ctx.selectActiveItem($event);
          })("keydown.space", function BrnSelectContentComponent_keydown_space_HostBindingHandler($event) {
            return ctx.selectActiveItem($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx._select.id() + "--content");
          i0.ɵɵattribute("aria-multiselectable", ctx._select.multiple())("aria-disabled", ctx._select.disabled() || ctx._select._formDisabled())("aria-activedescendant", ctx.keyManager == null ? null : ctx.keyManager.activeItem == null ? null : ctx.keyManager.activeItem.id())("aria-labelledBy", ctx._select.labelId())("aria-controlledBy", ctx._select.id() + "--trigger")("dir", ctx._select.dir());
        }
      },
      features: [i0.ɵɵProvidersFeature([provideBrnSelectContent(BrnSelectContentComponent)])],
      ngContentSelectors: _c2,
      decls: 9,
      vars: 2,
      consts: [["scrollUp", ""], ["viewport", ""], ["scrollDown", ""], [4, "ngTemplateOutlet"], ["data-brn-select-viewport", "", 2, "flex", "1 1 0%", "position", "relative", "width", "100%", "overflow", "auto", "min-height", "36px", "padding-bottom", "2px", "margin-bottom", "-2px", 3, "scroll"]],
      template: function BrnSelectContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c1);
          i0.ɵɵtemplate(0, BrnSelectContentComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, BrnSelectContentComponent_ng_container_2_Template, 1, 0, "ng-container", 3);
          i0.ɵɵelementStart(3, "div", 4, 1);
          i0.ɵɵlistener("scroll", function BrnSelectContentComponent_Template_div_scroll_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.handleScroll());
          });
          i0.ɵɵprojection(5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, BrnSelectContentComponent_ng_template_6_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, BrnSelectContentComponent_ng_container_8_Template, 1, 0, "ng-container", 3);
        }
        if (rf & 2) {
          const scrollUp_r2 = i0.ɵɵreference(1);
          const scrollDown_r3 = i0.ɵɵreference(7);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.canScrollUp() && ctx.scrollUpBtn() ? scrollUp_r2 : null);
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("ngTemplateOutlet", ctx.canScrollDown() && ctx.scrollDownBtn() ? scrollDown_r3 : null);
        }
      },
      dependencies: [NgTemplateOutlet],
      styles: ["[_nghost-%COMP%]{display:flex;box-sizing:border-box;flex-direction:column;outline:none;pointer-events:auto}[data-brn-select-viewport][_ngcontent-%COMP%]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch}[data-brn-select-viewport][_ngcontent-%COMP%]::-webkit-scrollbar{display:none}"],
      changeDetection: 0
    });
  }
  return BrnSelectContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectGroupDirective = /*#__PURE__*/(() => {
  class BrnSelectGroupDirective {
    labelledBy = signal('');
    /** @nocollapse */
    static ɵfac = function BrnSelectGroupDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectGroupDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectGroupDirective,
      selectors: [["", "brnSelectGroup", ""]],
      hostAttrs: ["role", "group"],
      hostVars: 1,
      hostBindings: function BrnSelectGroupDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-labelledby", ctx.labelledBy());
        }
      }
    });
  }
  return BrnSelectGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectLabelDirective = /*#__PURE__*/(() => {
  class BrnSelectLabelDirective {
    _group = inject(BrnSelectGroupDirective, {
      optional: true
    });
    _label = inject(BrnLabelDirective, {
      host: true
    });
    constructor() {
      this._group?.labelledBy.set(this._label.id());
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectLabelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectLabelDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectLabelDirective,
      selectors: [["", "brnSelectLabel", ""]],
      features: [i0.ɵɵHostDirectivesFeature([i1.BrnLabelDirective])]
    });
  }
  return BrnSelectLabelDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectPlaceholderDirective = /*#__PURE__*/(() => {
  class BrnSelectPlaceholderDirective {
    /** @internale */
    templateRef = inject(TemplateRef);
    /** @nocollapse */
    static ɵfac = function BrnSelectPlaceholderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectPlaceholderDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectPlaceholderDirective,
      selectors: [["", "brnSelectPlaceholder", ""], ["", "hlmSelectPlaceholder", ""]]
    });
  }
  return BrnSelectPlaceholderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectTriggerDirective = /*#__PURE__*/(() => {
  class BrnSelectTriggerDirective {
    _elementRef = inject(ElementRef);
    _select = injectBrnSelect();
    _ngControl = inject(NgControl, {
      optional: true
    });
    _platform = inject(PLATFORM_ID);
    _triggerId = computed(() => `${this._select.id()}--trigger`);
    _contentId = computed(() => `${this._select.id()}--content`);
    _disabled = computed(() => this._select.disabled() || this._select._formDisabled());
    _labelledBy = computed(() => {
      const value = this._select.value();
      if (Array.isArray(value) && value.length > 0) {
        return `${this._select.labelId()} ${this._select.id()}--value`;
      }
      return this._select.labelId();
    });
    _resizeObserver;
    constructor() {
      this._select.trigger.set(this);
    }
    ngAfterViewInit() {
      this._select.triggerWidth.set(this._elementRef.nativeElement.offsetWidth);
      // if we are on the client, listen for element resize events
      if (isPlatformBrowser(this._platform)) {
        this._resizeObserver = new ResizeObserver(() => this._select.triggerWidth.set(this._elementRef.nativeElement.offsetWidth));
        this._resizeObserver.observe(this._elementRef.nativeElement);
      }
    }
    ngOnDestroy() {
      this._resizeObserver?.disconnect();
    }
    focus() {
      this._elementRef.nativeElement.focus();
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectTriggerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectTriggerDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectTriggerDirective,
      selectors: [["", "brnSelectTrigger", ""]],
      hostAttrs: ["type", "button", "role", "combobox", "aria-autocomplete", "none"],
      hostVars: 18,
      hostBindings: function BrnSelectTriggerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.ArrowDown", function BrnSelectTriggerDirective_keydown_ArrowDown_HostBindingHandler() {
            return ctx._select.show();
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("disabled", ctx._disabled());
          i0.ɵɵattribute("id", ctx._triggerId())("aria-expanded", ctx._select.open())("aria-controls", ctx._contentId())("aria-labelledBy", ctx._labelledBy())("dir", ctx._select.dir());
          i0.ɵɵclassProp("ng-invalid", (ctx._ngControl == null ? null : ctx._ngControl.invalid) || null)("ng-dirty", (ctx._ngControl == null ? null : ctx._ngControl.dirty) || null)("ng-valid", (ctx._ngControl == null ? null : ctx._ngControl.valid) || null)("ng-touched", (ctx._ngControl == null ? null : ctx._ngControl.touched) || null)("ng-untouched", (ctx._ngControl == null ? null : ctx._ngControl.untouched) || null)("ng-pristine", (ctx._ngControl == null ? null : ctx._ngControl.pristine) || null);
        }
      }
    });
  }
  return BrnSelectTriggerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectValueDirective = /*#__PURE__*/(() => {
  class BrnSelectValueDirective {
    /** @internale */
    templateRef = inject(TemplateRef);
    /** @nocollapse */
    static ɵfac = function BrnSelectValueDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectValueDirective)();
    };
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BrnSelectValueDirective,
      selectors: [["", "brnSelectValue", ""], ["", "hlmSelectValue", ""]]
    });
  }
  return BrnSelectValueDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BrnSelectValueComponent = /*#__PURE__*/(() => {
  class BrnSelectValueComponent {
    _select = injectBrnSelect();
    id = computed(() => `${this._select.id()}--value`);
    placeholder = computed(() => this._select.placeholder());
    _showPlaceholder = computed(() => this.value() === null || this.value() === undefined || this.value() === '');
    /** Allow a custom value template */
    customValueTemplate = contentChild(BrnSelectValueDirective, {
      descendants: true
    });
    customPlaceholderTemplate = contentChild(BrnSelectPlaceholderDirective, {
      descendants: true
    });
    value = computed(() => {
      const value = this._values();
      if (value.length === 0) {
        return null;
      }
      // remove any selected values that are not in the options list
      const existingOptions = value.filter(val => this._select.options().some(option => this._select.compareWith()(option.value(), val)));
      const selectedOption = existingOptions.map(val => this._select.options().find(option => this._select.compareWith()(option.value(), val)));
      if (selectedOption.length === 0) {
        return null;
      }
      const selectedLabels = selectedOption.map(option => option?.getLabel());
      if (this._select.dir() === 'rtl') {
        selectedLabels.reverse();
      }
      return this.transformFn()(selectedLabels);
    });
    /** Normalize the values as an array */
    _values = computed(() => Array.isArray(this._select.value()) ? this._select.value() : [this._select.value()]);
    transformFn = input(values => (values ?? []).join(', '));
    /** @nocollapse */
    static ɵfac = function BrnSelectValueComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectValueComponent)();
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BrnSelectValueComponent,
      selectors: [["brn-select-value"], ["hlm-select-value"]],
      contentQueries: function BrnSelectValueComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.customValueTemplate, BrnSelectValueDirective, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.customPlaceholderTemplate, BrnSelectPlaceholderDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(2);
        }
      },
      hostVars: 2,
      hostBindings: function BrnSelectValueComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("id", ctx.id());
          i0.ɵɵattribute("data-placeholder", ctx._showPlaceholder() ? "" : null);
        }
      },
      inputs: {
        transformFn: [1, "transformFn"]
      },
      decls: 6,
      vars: 1,
      consts: [["defaultValueTemplate", ""], ["defaultPlaceholderTemplate", ""], [3, "ngTemplateOutlet"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function BrnSelectValueComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, BrnSelectValueComponent_Conditional_0_Template, 1, 1, "ng-container", 2)(1, BrnSelectValueComponent_Conditional_1_Template, 1, 4, "ng-container", 3)(2, BrnSelectValueComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, BrnSelectValueComponent_ng_template_4_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx._showPlaceholder() ? 0 : 1);
        }
      },
      dependencies: [NgTemplateOutlet],
      styles: ["[_nghost-%COMP%]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;white-space:nowrap;pointer-events:none}"],
      changeDetection: 0
    });
  }
  return BrnSelectValueComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let nextId = 0;
let BrnSelectComponent = /*#__PURE__*/(() => {
  class BrnSelectComponent {
    _defaultErrorStateMatcher = inject(ErrorStateMatcher);
    _parentForm = inject(NgForm, {
      optional: true
    });
    _injector = inject(Injector);
    _parentFormGroup = inject(FormGroupDirective, {
      optional: true
    });
    ngControl = inject(NgControl, {
      optional: true,
      self: true
    });
    id = input(`brn-select-${nextId++}`);
    multiple = input(false, {
      transform: booleanAttribute
    });
    placeholder = input('');
    disabled = input(false, {
      transform: booleanAttribute
    });
    dir = input('ltr');
    closeDelay = input(100, {
      transform: numberAttribute
    });
    open = model(false);
    value = model();
    compareWith = input((o1, o2) => o1 === o2);
    _formDisabled = signal(false);
    /** Label provided by the consumer. */
    selectLabel = contentChild(BrnLabelDirective, {
      descendants: false
    });
    /** Overlay pane containing the options. */
    selectContent = contentChild.required(BrnSelectContentComponent);
    /** @internal */
    options = contentChildren(BrnSelectOptionDirective, {
      descendants: true
    });
    /** @internal Derive the selected options to filter out the unselected options */
    selectedOptions = computed(() => this.options().filter(option => option.selected()));
    /** Overlay pane containing the options. */
    _overlayDir = viewChild.required(CdkConnectedOverlay);
    trigger = signal(null);
    triggerWidth = signal(0);
    _delayedExpanded = toSignal(toObservable(this.open).pipe(switchMap(expanded => !expanded ? of(expanded).pipe(delay(this.closeDelay())) : of(expanded)), takeUntilDestroyed()), {
      initialValue: false
    });
    state = computed(() => this.open() ? 'open' : 'closed');
    _positionChanges$ = new Subject();
    side = toSignal(this._positionChanges$.pipe(map(change =>
    // todo: better translation or adjusting hlm to take that into account
    change.connectionPair.originY === 'center' ? change.connectionPair.originX === 'start' ? 'left' : 'right' : change.connectionPair.originY)), {
      initialValue: 'bottom'
    });
    labelId = computed(() => this.selectLabel()?.id ?? `${this.id()}--label`);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _onChange = () => {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _onTouched = () => {};
    /*
     * This position config ensures that the top "start" corner of the overlay
     * is aligned with with the top "start" of the origin by default (overlapping
     * the trigger completely). If the panel cannot fit below the trigger, it
     * will fall back to a position above the trigger.
     */
    _positions = [{
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top'
    }, {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    }, {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom'
    }, {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom'
    }];
    errorStateTracker;
    errorState = computed(() => this.errorStateTracker.errorState());
    constructor() {
      if (this.ngControl !== null) {
        this.ngControl.valueAccessor = this;
      }
      this.errorStateTracker = new ErrorStateTracker(this._defaultErrorStateMatcher, this.ngControl, this._parentFormGroup, this._parentForm);
    }
    ngDoCheck() {
      this.errorStateTracker.updateErrorState();
    }
    toggle() {
      if (this.open()) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      if (this.open() || this.disabled() || this._formDisabled() || this.options()?.length == 0) {
        return;
      }
      this.open.set(true);
      afterNextRender(() => this.selectContent().focusList(), {
        injector: this._injector
      });
    }
    hide() {
      if (!this.open()) return;
      this.open.set(false);
      this._onTouched();
      // restore focus to the trigger
      this.trigger()?.focus();
    }
    writeValue(value) {
      this.value.set(value);
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this._formDisabled.set(isDisabled);
    }
    selectOption(value) {
      // if this is a multiple select we need to add the value to the array
      if (this.multiple()) {
        const currentValue = this.value();
        const newValue = currentValue ? [...currentValue, value] : [value];
        this.value.set(newValue);
      } else {
        this.value.set(value);
      }
      this._onChange?.(this.value());
      // if this is single select close the dropdown
      if (!this.multiple()) {
        this.hide();
      }
    }
    deselectOption(value) {
      if (this.multiple()) {
        const currentValue = this.value();
        this.value.set(currentValue.filter(val => !this.compareWith()(val, value)));
      } else {
        this.value.set(null);
      }
      this._onChange?.(this.value());
    }
    toggleSelect(value) {
      if (this.isSelected(value)) {
        this.deselectOption(value);
      } else {
        this.selectOption(value);
      }
    }
    isSelected(value) {
      const selection = this.value();
      if (Array.isArray(selection)) {
        return selection.some(val => this.compareWith()(val, value));
      } else if (value !== undefined) {
        return this.compareWith()(selection, value);
      }
      return false;
    }
    /** @nocollapse */
    static ɵfac = function BrnSelectComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectComponent)();
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BrnSelectComponent,
      selectors: [["brn-select"], ["hlm-select"]],
      contentQueries: function BrnSelectComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.selectLabel, BrnLabelDirective, 4);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.selectContent, BrnSelectContentComponent, 5);
          i0.ɵɵcontentQuerySignal(dirIndex, ctx.options, BrnSelectOptionDirective, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance(3);
        }
      },
      viewQuery: function BrnSelectComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx._overlayDir, CdkConnectedOverlay, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      inputs: {
        id: [1, "id"],
        multiple: [1, "multiple"],
        placeholder: [1, "placeholder"],
        disabled: [1, "disabled"],
        dir: [1, "dir"],
        closeDelay: [1, "closeDelay"],
        open: [1, "open"],
        value: [1, "value"],
        compareWith: [1, "compareWith"]
      },
      outputs: {
        open: "openChange",
        value: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([provideExposedSideProviderExisting(() => BrnSelectComponent), provideExposesStateProviderExisting(() => BrnSelectComponent), provideBrnSelect(BrnSelectComponent), {
        provide: BrnFormFieldControl,
        useExisting: BrnSelectComponent
      }])],
      ngContentSelectors: _c5,
      decls: 6,
      vars: 5,
      consts: [["trigger", "cdkOverlayOrigin"], [1, "hidden"], ["cdk-overlay-origin", "", 3, "click"], ["cdk-connected-overlay", "", "cdkConnectedOverlayLockPosition", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "cdk-overlay-transparent-backdrop", 3, "backdropClick", "detach", "positionChange", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayWidth"]],
      template: function BrnSelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c4);
          i0.ɵɵtemplate(0, BrnSelectComponent_Conditional_0_Template, 2, 2, "label", 1)(1, BrnSelectComponent_Conditional_1_Template, 1, 0);
          i0.ɵɵelementStart(2, "div", 2, 0);
          i0.ɵɵlistener("click", function BrnSelectComponent_Template_div_click_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggle());
          });
          i0.ɵɵprojection(4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, BrnSelectComponent_ng_template_5_Template, 1, 0, "ng-template", 3);
          i0.ɵɵlistener("backdropClick", function BrnSelectComponent_Template_ng_template_backdropClick_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.hide());
          })("detach", function BrnSelectComponent_Template_ng_template_detach_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.hide());
          })("positionChange", function BrnSelectComponent_Template_ng_template_positionChange_5_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx._positionChanges$.next($event));
          });
        }
        if (rf & 2) {
          const trigger_r3 = i0.ɵɵreference(3);
          i0.ɵɵconditional(!ctx.selectLabel() && ctx.placeholder() ? 0 : 1);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("cdkConnectedOverlayOrigin", trigger_r3)("cdkConnectedOverlayOpen", ctx._delayedExpanded())("cdkConnectedOverlayPositions", ctx._positions)("cdkConnectedOverlayWidth", ctx.triggerWidth() > 0 ? ctx.triggerWidth() : "auto");
        }
      },
      dependencies: [OverlayModule, i1$1.CdkConnectedOverlay, i1$1.CdkOverlayOrigin, CdkListboxModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return BrnSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BrnSelectImports = [BrnSelectComponent, BrnSelectContentComponent, BrnSelectTriggerDirective, BrnSelectOptionDirective, BrnSelectValueComponent, BrnSelectScrollDownDirective, BrnSelectScrollUpDirective, BrnSelectGroupDirective, BrnSelectLabelDirective, BrnSelectValueDirective, BrnSelectPlaceholderDirective];
let BrnSelectModule = /*#__PURE__*/(() => {
  class BrnSelectModule {
    /** @nocollapse */static ɵfac = function BrnSelectModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BrnSelectModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BrnSelectModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [BrnSelectComponent]
    });
  }
  return BrnSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BrnSelectComponent, BrnSelectContentComponent, BrnSelectGroupDirective, BrnSelectImports, BrnSelectLabelDirective, BrnSelectModule, BrnSelectOptionDirective, BrnSelectPlaceholderDirective, BrnSelectScrollDownDirective, BrnSelectScrollUpDirective, BrnSelectTriggerDirective, BrnSelectValueComponent, BrnSelectValueDirective };
